import { ReactNode } from "react";

import { Button } from "capitalrx-components";

import { formatDate } from "capitalrx-utilities";
import { GeneralTypes } from "@/types";
import { defaultDateFormat } from "@/App/constants/constants";

const listTableHeaders: Array<GeneralTypes.TableHeader> = [
  {
    key: "external_member_id",
    label: "Patient ID",
  },
  {
    key: "first_name",
    label: "First Name",
  },
  {
    key: "last_name",
    label: "Last Name",
  },
  {
    key: "birth_date",
    label: "Date of Birth",
    formatter: (v: string): string => {
      return formatDate(v, defaultDateFormat);
    },
  },
  {
    key: "person_code",
    label: "Person Code",
  },
  {
    key: "effective_date",
    label: "Effective Date",
    formatter: (v: string): string => {
      return formatDate(v, defaultDateFormat);
    },
  },
  {
    key: "termination_date",
    label: "Termination Date",
    formatter: (v: string): string => {
      return formatDate(v, defaultDateFormat);
    },
  },
  {
    key: "sex",
    label: "Gender",
    formatter: (v: string): string => {
      if (v === "F") return "Female";
      else if (v === "M") return "Male";
      else return "";
    },
  },
  {
    key: "address_line_1",
    label: "Street Address",
  },
  {
    key: "city",
    label: "City",
  },
  {
    key: "state",
    label: "State",
  },
  {
    key: "zip_code",
    label: "ZIP Code",
  },
  {
    key: "action",
    label: "",
    className: "right-span",
    formatter: (): ReactNode => {
      const component = (
        <Button buttonStyle="outline" color="darkblue" size="small">
          <span aria-hidden className="caprx-icon-input-plus" />
          ADD
        </Button>
      );
      return component;
    },
  },
];

export default listTableHeaders;
